module.exports = __webpack_public_path__ + "media/images/global/projects/math-8674050e80d2bcd9564f32e1458483d7.svg";